module.exports = __webpack_public_path__ + "assets/1f761dab54fb87461c4c4c1f124590be.mp3";